class ProductInfoAccordion extends HTMLElement {
  /** @type {WeakMap<HTMLDetailsElement, Animation>} */
  #animations = new WeakMap();

  connectedCallback() {
    this.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
  }

  #handleClick = (event) => {
    if (!(event.target instanceof Element)) return;

    const summary = event.target.closest('.product-info-accordion__summary');
    if (!summary || !this.contains(summary)) return;

    const details = summary.closest('details');
    const content = details?.querySelector('.product-info-accordion__content-wrapper');
    if (!(details instanceof HTMLDetailsElement) || !(content instanceof HTMLElement)) return;

    event.preventDefault();

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      details.open = !details.open;
      return;
    }

    this.#animations.get(details)?.cancel();

    if (details.open) {
      this.#close(details, content);
    } else {
      this.#open(details, content);
    }
  };

  /**
   * @param {HTMLDetailsElement} details
   * @param {HTMLElement} content
   */
  #open(details, content) {
    details.open = true;
    const endHeight = content.scrollHeight;

    const animation = content.animate(
      [
        { height: '0px', opacity: 0 },
        { height: `${endHeight}px`, opacity: 1 },
      ],
      { duration: 280, easing: 'ease', fill: 'both' }
    );

    this.#animations.set(details, animation);
    animation.addEventListener('finish', () => {
      if (this.#animations.get(details) !== animation) return;
      animation.cancel();
      content.style.height = 'auto';
      content.style.opacity = '1';
      this.#animations.delete(details);
    });
  }

  /**
   * @param {HTMLDetailsElement} details
   * @param {HTMLElement} content
   */
  #close(details, content) {
    const startHeight = content.getBoundingClientRect().height;
    content.style.height = '';
    content.style.opacity = '';

    const animation = content.animate(
      [
        { height: `${startHeight}px`, opacity: 1 },
        { height: '0px', opacity: 0 },
      ],
      { duration: 280, easing: 'ease', fill: 'both' }
    );

    this.#animations.set(details, animation);
    animation.addEventListener('finish', () => {
      if (this.#animations.get(details) !== animation) return;
      details.open = false;
      animation.cancel();
      content.style.height = '';
      content.style.opacity = '';
      this.#animations.delete(details);
    });
  }
}

if (!customElements.get('product-info-accordion')) {
  customElements.define('product-info-accordion', ProductInfoAccordion);
}
